export default {
  meta: {
    title: '加盟意向',
    url: '/join/index', // 埋点字段，上报归属的模块
    urlName: '加盟意向' // 埋点字段，上报归属的模块
  }
};
